module.exports = {"TXTWCL_Just_so_you_know":{"id":"TXTWCL_Just_so_you_know","defaultMessage":"Απλώς για να ξέρεις","track":"Just so you know"}}